/**
 * @generated SignedSource<<cc92ae410b350352622979a5c2ea9b69>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "TwoFactorSmsDeliveryStatus",
    "kind": "LinkedField",
    "name": "twoFactorSmsDeliveryStatus",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "occurredAt",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useSmsDeliveryStatusPollQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useSmsDeliveryStatusPollQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "b92c3c6599e7c2c0da9667eacfb7e219",
    "id": null,
    "metadata": {},
    "name": "useSmsDeliveryStatusPollQuery",
    "operationKind": "query",
    "text": "query useSmsDeliveryStatusPollQuery {\n  twoFactorSmsDeliveryStatus {\n    status\n    occurredAt\n  }\n}\n"
  }
};
})();

node.hash = "e49ffa9dbbd6def6c0b9ca500d000179";

module.exports = node;
